<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';

import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import AgentSelector from '../AgentSelector.vue';
import { useVuelidate } from '@vuelidate/core';

export default {
  components: {
    PageHeader,
    AgentSelector,
  },
  validations: {
    selectedAgents: {
      isEmpty() {
        return !!this.selectedAgents.length;
      },
    },
  },

  setup() {
    return { v$: useVuelidate() };
  },

  data() {
    return {
      selectedAgents: [],
      memberSettings: {}, // GK-HUB: { [agentId]: { receives_assignment } }
      isCreating: false,
    };
  },

  computed: {
    ...mapGetters({
      agentList: 'agents/getAgents',
    }),

    teamId() {
      return this.$route.params.teamId;
    },
    headerTitle() {
      return this.$t('TEAMS_SETTINGS.ADD.TITLE', {
        teamName: this.currentTeam.name,
      });
    },
    currentTeam() {
      return this.$store.getters['teams/getTeam'](this.teamId);
    },
  },

  mounted() {
    this.$store.dispatch('agents/get');
  },

  methods: {
    updateSelectedAgents(newAgentList) {
      this.v$.selectedAgents.$touch();
      this.selectedAgents = [...newAgentList];
      // GK-HUB (#115): default por role — agente nasce recebedor; não-agente (admin/supervisor/manager)
      // nasce OBSERVADOR. Alinha a UI ao gate desacoplado do backend (sync_members + migração); sem isso
      // o toggle default-ON enviaria receives_assignment:true explícito e não-agente viraria recebedor.
      const next = { ...this.memberSettings };
      newAgentList.forEach(id => {
        if (next[id] === undefined) {
          const agent = this.agentList.find(item => item.id === id);
          next[id] = { receives_assignment: agent?.role === 'agent' };
        }
      });
      this.memberSettings = next;
    },
    // GK-HUB: atualiza o papel (recebe-fila/observador) de um agente
    updateMemberSetting(agentId, receives) {
      this.memberSettings = {
        ...this.memberSettings,
        [agentId]: { receives_assignment: receives },
      };
    },
    selectAllAgents() {
      this.selectedAgents = this.agentList.map(agent => agent.id);
    },
    async addAgents() {
      this.isCreating = true;
      const { teamId, selectedAgents } = this;

      try {
        // GK-HUB: monta members[{ user_id, receives_assignment }]
        const members = selectedAgents.map(id => ({
          user_id: id,
          receives_assignment:
            this.memberSettings[id]?.receives_assignment !== false,
        }));
        await this.$store.dispatch('teamMembers/create', {
          teamId,
          members,
        });
        router.replace({
          name: 'settings_teams_finish',
          params: {
            page: 'new',
            teamId,
          },
        });
        this.$store.dispatch('teams/get');
      } catch (error) {
        useAlert(error.message);
      }
      this.isCreating = false;
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <form
      class="flex flex-wrap mx-0 overflow-x-auto"
      @submit.prevent="addAgents"
    >
      <div class="w-full">
        <PageHeader
          :header-title="headerTitle"
          :header-content="$t('TEAMS_SETTINGS.ADD.DESC')"
        />
      </div>

      <div class="w-full">
        <div v-if="v$.selectedAgents.$error">
          <p class="error-message pb-2">
            {{ $t('TEAMS_SETTINGS.ADD.AGENT_VALIDATION_ERROR') }}
          </p>
        </div>
        <AgentSelector
          :agent-list="agentList"
          :selected-agents="selectedAgents"
          :update-selected-agents="updateSelectedAgents"
          :member-settings="memberSettings"
          :update-member-setting="updateMemberSetting"
          :is-working="isCreating"
          :submit-button-text="$t('TEAMS_SETTINGS.ADD.BUTTON_TEXT')"
        />
      </div>
    </form>
  </div>
</template>
